import { useId } from 'react';

// Isotipo de MONIMEX: una "M" cuya pierna derecha es una flecha hacia arriba (tu dinero creciendo).
export function Isotipo({ className = 'h-8 w-8', titulo }) {
  const id = useId().replace(/:/g, '');
  return (
    <svg viewBox="0 0 512 512" className={className} role={titulo ? 'img' : undefined} aria-hidden={titulo ? undefined : true} aria-label={titulo}>
      <defs>
        <linearGradient id={`mx${id}`} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#4338CA" />
          <stop offset="0.55" stopColor="#6366F1" />
          <stop offset="1" stopColor="#10B981" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="116" fill={`url(#mx${id})`} />
      <g transform="translate(-24 0)" fill="none" stroke="#fff" strokeWidth="54" strokeLinecap="round" strokeLinejoin="round">
        <path d="M132 382 V180 L248 302 L364 196" />
        <path d="M364 382 V132" />
        <path d="M308 182 L364 124 L420 182" />
      </g>
    </svg>
  );
}

// Logotipo completo: isotipo + "MONI" + "MEX". `tono` = 'auto' (sigue el modo oscuro), 'claro' (sobre fondo oscuro) u 'oscuro'.
export default function Logo({ className = '', iconClassName = 'h-8 w-8', textClassName = 'text-xl', tono = 'auto', soloIcono = false }) {
  const moni = tono === 'claro' ? 'text-white' : tono === 'oscuro' ? 'text-slate-900' : 'text-slate-900 dark:text-white';
  const mex = tono === 'claro' ? 'text-indigo-300' : tono === 'oscuro' ? 'text-indigo-600' : 'text-indigo-600 dark:text-indigo-300';
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <Isotipo className={`${iconClassName} shrink-0`} titulo={soloIcono ? 'MONIMEX' : undefined} />
      {!soloIcono && (
        <span className={`font-extrabold tracking-tight leading-none ${textClassName}`}>
          <span className={moni}>MONI</span><span className={mex}>MEX</span>
        </span>
      )}
    </span>
  );
}
